import "./ChatTranscript.css";
import { For } from "solid-js";
import type { ContextAnswer } from "../../components/ContextAnswerPill.tsx";
import type { ChatPanelUiState } from "../chatPanelState.ts";
import type { ChatPanelController } from "../useChatPanelController.ts";
import { ChatInteraction } from "./ChatInteraction.tsx";

type Props = {
	state: ChatPanelUiState;
	questionId: string;
	projectId: string | null;
	controller: ChatPanelController;
	onTranscriptRef: (el: HTMLDivElement) => void;
	/** The saved answer the conversation started with, shown on its first question. */
	contextAnswer?: ContextAnswer;
};

export const ChatTranscript = (props: Props) => {
	return (
		<div
			class="transcript"
			classList={{ reasoning: props.state.isReasoning }}
			ref={props.onTranscriptRef}
		>
			<For each={props.state.interactions}>
				{(interaction, index) => (
					<ChatInteraction
						interaction={interaction}
						questionId={props.questionId}
						projectId={props.projectId}
						renderingHistory={props.state.renderingHistory}
						scrollToInteractionIndex={props.state.scrollToInteractionIndex}
						controller={props.controller}
						reasoning={
							props.state.isReasoning &&
							!props.state.renderingHistory &&
							index() === props.state.interactions.length - 1
						}
						contextAnswer={index() === 0 ? props.contextAnswer : undefined}
					/>
				)}
			</For>
		</div>
	);
};
